<template>
  <div id="resetPassword">
    <div class="navbar-fixed">
      <nav style="background-color: #313131">
        <div class="nav-wrapper navbar-margin">
          <div class="brand-logo center">
            <a href="/" > 
              <img src="../assets/SmartX_Logo.png" width="141.6" height="32" style="padding-top: 5px"> 
            </a>
          </div>
        </div>
      </nav>
    </div>
    <div class="container" :style="{width: '500px'}">
      <div class="card-panel">
        <div class="row">
          <div class="col s12">
            <div class="center">Passwort vergessen</div>
            <div class="input-field">
              <input type="email" id="email" v-model="email" />
              <label for="email" class="black-text">Email</label>
            </div>

            <div class="center">
              <a
                class="btn black"
                :style="{margin: '30px'}"
                v-on:click="resetPasswordClicked"
              >Passwort vergessen</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  name: "resetPassword",
  data() {
    return {
      email: ""
    };
  },

  methods: {
    resetPasswordClicked() {
    var actionCodeSettings = {
      url: 'https://fmp20-260516.firebaseapp.com',
      handleCodeInApp: false
    };

    firebase.auth().sendPasswordResetEmail(this.email, actionCodeSettings)
      .then(function() {
        alert("Wir haben Ihren Link zum Zurücksetzen des Passworts per E-Mail gesendet!");
      })
      .catch(function(error) {
        alert(error);
      });
    }
  }
};
</script>